import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuth } from '../lib/auth/auth-context';

// The Dashboard landing page was retired 2026-07-08 — its KPI strip
// duplicated per-page summaries and its "Today's routes" panel just
// bounced users to Orders. `/` now dispatches straight to the caller's
// working surface. See git history for the previous DispatcherHomePage
// implementation (KPIs + recent-activity feed) if we ever revisit a
// real "attention" dashboard.
export const Route = createFileRoute('/_authenticated/')({
  component: HomeRedirect,
});

// Local-calendar today (YYYY-MM-DD). Duplicated here rather than
// imported to keep the redirect route free of larger route-utility
// deps; /dispatch's own validateSearch would fall back to its internal
// todayIso() anyway if we passed something bogus, but supplying a
// well-formed date keeps the URL clean on first paint.
function todayIso(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function HomeRedirect(): JSX.Element {
  const { userType, isReady } = useAuth();
  // Wait for auth claims before redirecting — otherwise dispatchers
  // briefly land on the pharmacy default before we know their role.
  if (!isReady) return <div />;
  // Dispatchers → their morning workload planner. Everyone else
  // (pharmacy_admin, pharmacy_staff, platform_admin) → Orders, which
  // IS the pharmacy-side working surface. `driver` shouldn't reach
  // the web portal but if they do, Orders is the safest default.
  if (userType === 'dispatcher') {
    return <Navigate to="/dispatch" search={{ date: todayIso() }} replace />;
  }
  return <Navigate to="/orders" search={{ status: 'all' }} replace />;
}
